import { ChildProps } from '@apollo/client/react/hoc';
import { gql } from '@apollo/client';
import React from 'react';
import I18n from 'i18n-js';
import FormSection from '@reverbdotcom/commons/src/components/form_section';
import MyAccountCreditCardList, { MyAccountCreditCardListFragment } from './MyAccountCreditCardList';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import { CoreMyAccountCreditCardsLayout } from '../schemas/rql';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import { Paths } from './shared/url_helpers';

type Props = ChildProps<unknown, CoreMyAccountCreditCardsLayout.Query>;

export function MyAccountCreditCardsLayout(props: Props) {
  const creditCards = props.data?.me?.creditCards || [];

  return (
    <FormSection
      title={I18n.t('discovery.myAccountCreditCards.layout.title')}
      description={<Description />}
      loading={!props.data || props.data.loading}
    >
      <MyAccountCreditCardList creditCards={creditCards} />
    </FormSection>
  );
}

function Description() {
  return (
    <Translate
      html
      text="discovery.myAccountCreditCards.layout.description"
      args={{ linkOpen: `<a href="${Paths.sellerStatements.expand({})}">`, linkClose: '</a>' }}
    />
  );
}

const withQuery = withGraphql<unknown, CoreMyAccountCreditCardsLayout.Query>(
  gql`
    query Core_MyAccount_CreditCardsLayout {
      me {
        uuid
        ...MyAccountCreditCardListFields
      }
    }
    ${MyAccountCreditCardListFragment}
  `,
  {
    options: {
      errorPolicy: 'all',
    },
  },
);

export default withQuery(MyAccountCreditCardsLayout);
